<template>
    <div>
        <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
            <app-sidebar></app-sidebar>
            <div id="page-content-wrapper" style="width:100%">
                <i class="material-icons print-media" id="menu-toggle" @click="isSidebar =  !isSidebar" style="cursor:pointer">view_headline</i>
                <app-navbar></app-navbar>
                <div class="container-fluid mt-5">
                    <div class="col-sm-12">
                        <div class="row dblock print-media">
                            <div class="row">
                                <div class="col-md-12 print-media">
                                    <vs-breadcrumb align="left" :items="
                      [
                        {title: 'You are here : '},
                        {
                          title: 'Analytics Report',
                          active: true
                        }
                      ]"></vs-breadcrumb>
                                  
                                </div>
                            </div>
                        </div>
                       
                       <AnalyticsGraph/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    import Navbar from "./Navbar";
    import Sidebar from "./Sidebar";
    import AnalyticsGraph from "../../commonPages/AnalyticsGraph.vue";

    
    export default {
        data: () => ({
            isSidebar: false,
            
        }),
      
        components: {
            "app-navbar": Navbar,
            "app-sidebar": Sidebar,
            AnalyticsGraph
        },
     
    
    };
    </script>
    
    <style scoped>
    .myNavbar {
        color: rgb(255, 255, 255);
    }
    @media print {
        .print-media {
            display: none;
        }
    }
    </style>